<template>
  <div class="file-preview">
    <iframe v-if="iframeSrc" :src="iframeSrc" class="preview-pdf"></iframe>

    <ZoomableImage
      v-else-if="file?.type.startsWith('image/') && objectUrl"
      :src="objectUrl"
      :alt="file.name"
      image-class="max-w-full rounded"
    />

    <div v-else class="preview-fallback">
      <p class="fallback-title">Apercu non disponible</p>
      <p v-if="file" class="fallback-filename">{{ file.name }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useObjectUrl } from "@vueuse/core";
import { getPdfUrlForIframe } from "@asap/shared/utils/string";
import ZoomableImage from "./ZoomableImage.vue";

interface Props {
  file?: File;
  url?: string;
}

const props = defineProps<Props>();

const fileObject = computed(() => props.file ?? undefined);
const objectUrl = useObjectUrl(fileObject);

const iframeSrc = computed(() => {
  if (props.url) return getPdfUrlForIframe(props.url);
  if (props.file?.type === "application/pdf") return objectUrl.value;
  return undefined;
});
</script>

<style scoped lang="scss">
.file-preview {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  background: #f9fafb;
}

.preview-pdf {
  width: 100%;
  height: 100%;
}

.preview-fallback {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
}

.fallback-title {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.fallback-filename {
  font-size: 0.875rem;
  color: #9ca3af;
}
</style>
